// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `v-tableSelect {
  -webkit-user-select: none;
          user-select: none;
}
v-tableSelect .treeTable-entry {
  padding: var(--table-select-padding);
}
v-tableSelect .treeTable-entry:hover {
  background: var(--table-select-background-hover);
}
v-tableSelect .treeTable-entry[level="0"] > * {
  border-left: none;
}
v-tableSelect .treeTable-entry > * {
  padding: var(--table-select-padding-children);
  border-left: var(--table-select-border-left);
  min-height: var(--table-select-min-height);
}
v-tableSelect .treeTable-entry p-treetabletoggler > button {
  margin-right: var(--table-select-margin-right) !important;
  margin-left: var(--table-select-margin-left) !important;
}
v-tableSelect .treeTable-entry v-icon {
  width: var(--table-select-icon-width);
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
v-tableSelect .treeTable-entry .title {
  margin-left: var(--table-select-margin-left-title);
  cursor: pointer;
}
v-tableSelect .childNode {
  margin-left: var(--table-select-margin-left-children);
}
v-tableSelect .state-icon {
  margin-top: var(--table-select-margin-top);
}`, "",{"version":3,"sources":["webpack://./src/app/modules/wrappers/lib/tableSelect/tableSelect.component.sass"],"names":[],"mappings":"AAAA;EACI,yBAAA;UAAA,iBAAA;AACJ;AAAI;EACI,oCAAA;AAER;AADQ;EACI,gDAAA;AAGZ;AAFQ;EACI,iBAAA;AAIZ;AAHQ;EACI,6CAAA;EACA,4CAAA;EACA,0CAAA;AAKZ;AAJQ;EACI,yDAAA;EACA,uDAAA;AAMZ;AAJQ;EACI,qCAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAMZ;AAJQ;EACI,kDAAA;EACA,eAAA;AAMZ;AALI;EACI,qDAAA;AAOR;AANI;EACI,0CAAA;AAQR","sourcesContent":["v-tableSelect\n    user-select: none\n    .treeTable-entry\n        padding: var(--table-select-padding)\n        &:hover\n            background: var(--table-select-background-hover)\n        &[level=\"0\"] > *\n            border-left: none\n        > *\n            padding: var(--table-select-padding-children)\n            border-left: var(--table-select-border-left)\n            min-height: var(--table-select-min-height)\n        p-treetabletoggler > button\n            margin-right: var(--table-select-margin-right) !important\n            margin-left: var(--table-select-margin-left) !important\n\n        v-icon\n            width: var(--table-select-icon-width)\n            aspect-ratio: 1\n            display: flex\n            align-items: center\n            justify-content: center\n\n        .title\n            margin-left: var(--table-select-margin-left-title)\n            cursor: pointer\n    .childNode\n        margin-left: var(--table-select-margin-left-children)\n    .state-icon\n        margin-top: var(--table-select-margin-top)"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
